<!-- =========================================================================================
  File Name: ItemGridView.vue
  Description: Item Component - Grid VIew
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
            <vx-card class="mb-base" v-on="$listeners">
                <template slot="no-body">

                    <!-- ITEM IMAGE -->
                    <div class="flex justify-between flex-wrap ">
                    <router-link :to="{ path: '/folder' +'/'+ item.id}" class="text-inherit " >
                    <div class="cursor-pointer" >
                        <vs-tooltip :text="item.name">
                        <img src="@/assets/images/pages/folder.svg" :alt="item.name" class="grid-view-img px-4 py-2">
                        </vs-tooltip>
                    </div>
                    </router-link>
                        <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer">
                                <div>
                                <feather-icon icon="MoreVerticalIcon" @click.stop="" svgClasses="w-4 h-4 hover:text-primary stroke-current"/>
                                </div>
                            <vs-dropdown-menu>
                            <vs-dropdown-item @click="deleteFolder(item.id)">
                            <span class="flex items-center"  >
                                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                                <span>Delete</span>
                            </span>
                            </vs-dropdown-item>

     

                            </vs-dropdown-menu>
                            </vs-dropdown>
                      
                    </div>

                </template>
            </vx-card>
            
            
</template>

<script>
import {
DELETE_IMG_LIBRARY_FOLDER
} from '@/graphql'
export default{
    components: {
   
  },

data () {
    return {
      img_cdn:null

    }
  },
  props: {
    item: {
     type: Object,
      required: true
    }
  },
  methods: {
    deleteFolder(id){
      this.$apollo
        .mutate({
          mutation: DELETE_IMG_LIBRARY_FOLDER,
          variables: {
                id: id,
          }
        })
        .then(response => {
            if(response.data.deleteImgLibraryFolder.status==='Success'){
                this.$emit('getdata','fbfolder')
            }
            else{
                this.$vs.notify({
                  title: 'Images',
                  text:  response.data.deleteImgLibraryFolder.message,
                  color: 'danger',
                  position: 'top-right'
                })
            }
        }
        )
    },

  },
    created () {
    this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
    this.img_cdn=this.img_cdn.replace('/images','');
  }
}
</script>

<style lang="scss" scoped>
.grid-view-item {
    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>